module.exports = __webpack_public_path__ + "mc.svg?32dc11e1be58917ca434dde32dbb5615";